import type { PromoBannerBackgroundTypes } from './PromoBanner.types';

import { cn } from 'helpers/classnames';

export const baseClasses = 'flex w-full items-center justify-center px-1 py-2 body-m';

// 150 slashes, no hard requirements it just covers most screens.
//content specifies alt text to hide from screen readers in the form of { content: '////' : '' };
//tailwind does not allow space characters, their docs specify to use _ in its place.
export const beforePseudoClasses =
  "before:flex before:flex-1 before:justify-end before:mr-2 before:overflow-hidden before:tracking-[1.44px] before:content-['//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////'_/_'']";

export const afterPseudoClasses =
  "after:flex after:flex-1 after:justify-start after:ml-2 after:overflow-hidden after:tracking-[1.44px] after:content-['//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////'_/_'']";

export const backgroundColorClasses: Record<PromoBannerBackgroundTypes, string> = {
  primary: '!bg-gray-0 !text-gray-900',
  secondary: 'bg-secondary-subtle ',
  tertiary: 'bg-tertiary-subtle'
};

export const linkTextClasses = cn(
  'underline ml-2 underline-offset-4 cursor-pointer visited:link-visited capitalize',
  'hover:decoration-2 font-medium'
);
